module.exports = __webpack_public_path__ + "media/newstyle/images/icon-burger-purple-d4523fef96b3a1955eb1eaa82b517d83.svg";